(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-advisor"] && !Shopify.designMode) return;
  try {
    (() => {
    const LEGACY_PROFILE_KEY = 'pinflag_size_advisor_profile_v1';
    const PROFILES_KEY = 'pinflag_size_advisor_profiles_v1';
    const ACTIVE_PROFILE_KEY = 'pinflag_size_advisor_active_id_v1';
    const AUTO_APPLIED = new Set();
    const dataPromiseCache = new Map();
    const recCache = new WeakMap(); // modalRoot -> recomendación actual (para "Editar Medidas" / carrusel)
    const RUN_IDS = new WeakMap(); // modalRoot -> id del último cálculo pedido (ver runRecommendation)
    const EASE_MIN_CM = 0;
    const EASE_MAX_CM = 16;
    const MEASURE_SLIDER_SPAN_CM = 20;

    const MONTH_SINGLE_RE = /^(\d+(?:\.\d+)?)\s*M$/i;
    const MONTH_RANGE_RE = /^(\d+)\s*-\s*(\d+)\s*M$/i;
    const YEAR_RE = /^(\d+(?:\.\d+)?)\s*A$/i;

    const DIMENSIONS = [
      { label: 'Tórax', columnRe: /pecho/i, bodyField: 'chest_cm' },
      { label: 'Cintura', columnRe: /cintura/i, bodyField: 'waist_cm' },
      { label: 'Cadera', columnRe: /cadera/i, bodyField: 'hip_cm' },
    ];

    // --- Perfiles guardados (multi-perfil, para varios hijos en la misma sesión) ---
    // Todos los perfiles y cuál está activo se guardan en localStorage, compartidos
    // entre todos los productos/modales (no son por producto).

    function readJsonLS(key) {
      try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    function writeJsonLS(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
      } catch (error) {
        // localStorage unavailable (ej. modo privado) - el perfil solo dura esta vista.
        return false;
      }
    }

    function removeLS(key) {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        // no-op
      }
    }

    function generateProfileId() {
      return 'p_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }

    // Migra el formato v1 (un solo perfil) a la lista de perfiles, la primera vez
    // que se carga el modal con el nuevo formato. No pisa datos si ya existe la
    // lista nueva (para no revivir un perfil viejo ya reemplazado/eliminado).
    function migrateLegacyProfile() {
      if (readJsonLS(PROFILES_KEY)) return;
      const legacy = readJsonLS(LEGACY_PROFILE_KEY);
      if (!legacy) return;
      const profile = Object.assign({ id: generateProfileId(), name: 'Mi perfil' }, legacy);
      // Solo se borra el formato viejo si la lista nueva quedó realmente escrita,
      // para no perder el perfil si localStorage rechaza la escritura (cuota/modo privado).
      if (!writeJsonLS(PROFILES_KEY, [profile])) return;
      setActiveProfileId(profile.id);
      removeLS(LEGACY_PROFILE_KEY);
    }

    function getProfiles() {
      return readJsonLS(PROFILES_KEY) || [];
    }

    function saveProfiles(profiles) {
      writeJsonLS(PROFILES_KEY, profiles);
    }

    function getActiveProfileId() {
      try {
        return localStorage.getItem(ACTIVE_PROFILE_KEY);
      } catch (error) {
        return null;
      }
    }

    function setActiveProfileId(id) {
      try {
        if (id) localStorage.setItem(ACTIVE_PROFILE_KEY, id);
        else localStorage.removeItem(ACTIVE_PROFILE_KEY);
      } catch (error) {
        // no-op
      }
    }

    function getActiveProfile() {
      const id = getActiveProfileId();
      if (!id) return null;
      return getProfiles().find((profile) => profile.id === id) || null;
    }

    function getCategoryMeta(sectionId) {
      const node = document.getElementById('SizeAdvisorCategory-' + sectionId);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    function loadJson(url) {
      if (!url) return Promise.resolve(null);
      if (dataPromiseCache.has(url)) return dataPromiseCache.get(url);
      const promise = fetch(url)
        .then((res) => (res.ok ? res.json() : null))
        .catch(() => null);
      dataPromiseCache.set(url, promise);
      return promise;
    }

    // --- Clasificación de la tabla de tallas de la categoría ---

    function tallaColumnKey(columnas) {
      return columnas[0] === 'Rango de edad' ? columnas[1] : columnas[0];
    }

    function classifyGuide(guide) {
      if (!guide || !guide.columnas || !guide.filas || !guide.filas.length) return 'unsupported';
      if (guide.columnas.some((c) => /largo de pie/i.test(c))) return 'shoe';
      const tCol = tallaColumnKey(guide.columnas);
      const values = guide.filas.map((row) => String(row[tCol]).trim());
      if (values.every((v) => MONTH_SINGLE_RE.test(v) || MONTH_RANGE_RE.test(v))) return 'baby';
      if (values.every((v) => YEAR_RE.test(v))) return 'kid';
      return 'unsupported';
    }

    function parseMonths(value) {
      const v = String(value).trim();
      const range = v.match(MONTH_RANGE_RE);
      if (range) return (parseFloat(range[1]) + parseFloat(range[2])) / 2;
      const single = v.match(MONTH_SINGLE_RE);
      return single ? parseFloat(single[1]) : null;
    }

    function parseYears(value) {
      const match = String(value).trim().match(YEAR_RE);
      return match ? parseFloat(match[1]) : null;
    }

    function availableDimensions(guide) {
      return DIMENSIONS
        .map((dim) => ({ ...dim, columnKey: guide.columnas.find((c) => dim.columnRe.test(c)) }))
        .filter((dim) => dim.columnKey);
    }

    // Cuántos cm cambia en promedio una columna de una talla a la siguiente en esta
    // categoría - se usa como "1 talla de diferencia" para calibrar qué tan lejos de
    // la talla recomendada es aceptable, en vez de un umbral de cm fijo (que no
    // generaliza entre prendas ajustadas y prendas holgadas por diseño).
    function computeStepSize(guide, columnKey) {
      const values = guide.filas.map((row) => row[columnKey]).filter((v) => v != null);
      if (values.length < 2) return null;
      let total = 0;
      for (let i = 1; i < values.length; i += 1) total += Math.abs(values[i] - values[i - 1]);
      return total / (values.length - 1);
    }

    // Más de 2 "tallas típicas" de diferencia de holgura respecto a la talla
    // recomendada se considera fuera de rango aceptable (muy apretado o muy ancho).
    const DEVIATION_BAD_THRESHOLD = 2;

    function evaluateFit(guide, estimate, recommendedIndex, index) {
      if (!estimate || recommendedIndex === -1) return { isBad: false, badDims: [] };
      const recRow = guide.filas[recommendedIndex];
      const row = guide.filas[index];
      const badDims = [];
      availableDimensions(guide).forEach((dim) => {
        const bodyValue = estimate[dim.bodyField];
        const garmentRec = recRow[dim.columnKey];
        const garmentRow = row[dim.columnKey];
        if (bodyValue == null || garmentRec == null || garmentRow == null) return;
        const step = computeStepSize(guide, dim.columnKey);
        if (!step) return;
        const deviation = (garmentRow - garmentRec) / step;
        if (Math.abs(deviation) > DEVIATION_BAD_THRESHOLD) badDims.push(dim.bodyField);
      });
      return { isBad: badDims.length > 0, badDims };
    }

    // --- Recomendación para categorías tipo "baby" (talla = rango de edad) ---

    function recommendBabyIndex(guide, profile) {
      const tCol = tallaColumnKey(guide.columnas);
      let bestIndex = -1;
      let bestDist = Infinity;
      guide.filas.forEach((row, idx) => {
        const months = parseMonths(row[tCol]);
        if (months == null) return;
        const dist = Math.abs(months - profile.ageMonths);
        if (dist < bestDist) {
          bestDist = dist;
          bestIndex = idx;
        }
      });
      return bestIndex;
    }

    // --- Recomendación para categorías tipo "kid" (talla = años) ---

    function averageAnthroRows(boyRows, girlRows) {
      const byAge = new Map();
      (boyRows || []).forEach((row) => byAge.set(row.age_years, { boy: row }));
      (girlRows || []).forEach((row) => {
        const entry = byAge.get(row.age_years) || {};
        entry.girl = row;
        byAge.set(row.age_years, entry);
      });
      const combined = [];
      byAge.forEach(({ boy, girl }, ageYears) => {
        const pick = (field) => {
          const values = [boy && boy[field], girl && girl[field]].filter((v) => v != null);
          if (!values.length) return null;
          return values.reduce((a, b) => a + b, 0) / values.length;
        };
        combined.push({
          age_years: ageYears,
          height_cm: pick('height_cm'),
          weight_kg: pick('weight_kg'),
          chest_cm: pick('chest_cm'),
          waist_cm: pick('waist_cm'),
          hip_cm: pick('hip_cm'),
        });
      });
      return combined;
    }

    // Estima la "edad equivalente" a partir de cualquier medida (altura, o un
    // contorno editado a mano), interpolando linealmente entre los dos registros
    // de edad de la base antropométrica cuyo valor de ese campo (percentil 50) más
    // se acerca al valor dado. Se usa la edad como variable puente en vez de
    // comparar cm de prenda contra cm de cuerpo directamente: así el mismo
    // criterio funciona tanto para prendas ajustadas (calzas, bermudas) como para
    // prendas holgadas por diseño (chaquetas, parkas), donde el contorno de la
    // prenda es deliberadamente mucho mayor que el contorno corporal y una
    // comparación de cm absolutos siempre "calzaría" en la talla más chica.
    function estimateAgeByField(rows, value, field) {
      if (value == null) return null;
      const sorted = rows.filter((r) => r[field] != null).sort((a, b) => a[field] - b[field]);
      if (!sorted.length) return null;
      if (value <= sorted[0][field]) return sorted[0].age_years;
      if (value >= sorted[sorted.length - 1][field]) return sorted[sorted.length - 1].age_years;
      let lo = sorted[0];
      let hi = sorted[sorted.length - 1];
      for (let i = 0; i < sorted.length - 1; i += 1) {
        if (value >= sorted[i][field] && value <= sorted[i + 1][field]) {
          lo = sorted[i];
          hi = sorted[i + 1];
          break;
        }
      }
      const span = hi[field] - lo[field];
      const t = span === 0 ? 0 : (value - lo[field]) / span;
      return lo.age_years + (hi.age_years - lo.age_years) * t;
    }

    function estimateBodyByHeight(rows, heightCm) {
      const chest = estimateFieldByHeight(rows, heightCm, 'chest_cm');
      const waist = estimateFieldByHeight(rows, heightCm, 'waist_cm');
      const hip = estimateFieldByHeight(rows, heightCm, 'hip_cm');
      return { chest_cm: chest, waist_cm: waist, hip_cm: hip };
    }

    function estimateFieldByHeight(rows, heightCm, targetField) {
      const sorted = rows.filter((r) => r.height_cm != null).sort((a, b) => a.height_cm - b.height_cm);
      if (!sorted.length) return null;
      if (heightCm <= sorted[0].height_cm) return sorted[0][targetField];
      if (heightCm >= sorted[sorted.length - 1].height_cm) return sorted[sorted.length - 1][targetField];
      let lo = sorted[0];
      let hi = sorted[sorted.length - 1];
      for (let i = 0; i < sorted.length - 1; i += 1) {
        if (heightCm >= sorted[i].height_cm && heightCm <= sorted[i + 1].height_cm) {
          lo = sorted[i];
          hi = sorted[i + 1];
          break;
        }
      }
      const span = hi.height_cm - lo.height_cm;
      const t = span === 0 ? 0 : (heightCm - lo.height_cm) / span;
      return lo[targetField] + (hi[targetField] - lo[targetField]) * t;
    }

    function recommendKidIndex(guide, ageEquivalentYears) {
      const tCol = tallaColumnKey(guide.columnas);
      let bestIndex = -1;
      let bestDist = Infinity;
      guide.filas.forEach((row, idx) => {
        const years = parseYears(row[tCol]);
        if (years == null) return;
        const dist = Math.abs(years - ageEquivalentYears);
        if (dist < bestDist) {
          bestDist = dist;
          bestIndex = idx;
        }
      });
      return bestIndex;
    }

    // La edad-equivalente por altura da un ancla category-agnostic (evita el sesgo
    // hacia la talla más chica que rompía a las prendas holgadas por diseño), pero
    // no sabe si ESTA categoría en particular corta ajustado o holgado para esa
    // edad - por eso un pantalón puede quedar mucho más apretado que una polera en
    // la misma talla nominal "2A". Este paso refina la elección: entre las tallas
    // cercanas al ancla (±REFINE_WINDOW), elige la que mejor calza con la
    // preferencia de calce del usuario (ajustado/intermedio/ancho).
    const REFINE_WINDOW = 2;
    const FIT_TARGET_POSITION = { tight: 15, medium: 50, loose: 85 };
    // Si la propia talla-ancla (elegida por edad) ya cae muy fuera de este rango en
    // una dimensión, esa dimensión no sirve para elegir en esta categoría - es la
    // señal de una prenda holgada por diseño en TODAS sus tallas (chaquetas,
    // parkas), donde comparar contra un objetivo fijo siempre terminaría eligiendo
    // la talla más chica de la ventana sin importar la preferencia. Se descarta esa
    // dimensión y se confía en el ancla por edad para ella.
    const ANCHOR_SANITY_MIN = -20;
    const ANCHOR_SANITY_MAX = 100;

    function refineIndexByPreference(guide, estimate, anchorIndex, fitPreference) {
      if (!estimate || anchorIndex === -1) return anchorIndex;
      const anchorRow = guide.filas[anchorIndex];
      const dims = availableDimensions(guide).filter((dim) => {
        const garmentValue = anchorRow[dim.columnKey];
        const bodyValue = estimate[dim.bodyField];
        if (garmentValue == null || bodyValue == null) return false;
        const anchorPosition = easeToRawPosition(garmentValue - bodyValue);
        return anchorPosition > ANCHOR_SANITY_MIN && anchorPosition < ANCHOR_SANITY_MAX;
      });
      if (!dims.length) return anchorIndex;

      const target = FIT_TARGET_POSITION[fitPreference] ?? FIT_TARGET_POSITION.medium;
      const start = Math.max(0, anchorIndex - REFINE_WINDOW);
      const end = Math.min(guide.filas.length - 1, anchorIndex + REFINE_WINDOW);

      let bestIndex = anchorIndex;
      let bestDist = Infinity;
      for (let idx = start; idx <= end; idx += 1) {
        const row = guide.filas[idx];
        const positions = dims
          .map((dim) => {
            const garmentValue = row[dim.columnKey];
            const bodyValue = estimate[dim.bodyField];
            if (garmentValue == null || bodyValue == null) return null;
            return easeToRawPosition(garmentValue - bodyValue);
          })
          .filter((p) => p != null);
        if (!positions.length) continue;
        const avgPosition = positions.reduce((a, b) => a + b, 0) / positions.length;
        const dist = Math.abs(avgPosition - target);
        if (dist < bestDist) {
          bestDist = dist;
          bestIndex = idx;
        }
      }
      return bestIndex;
    }

    // --- Orquestación: construye todo lo necesario para renderizar el paso 3 ---

    async function buildRecommendation(sectionId, profile) {
      const categoryMeta = getCategoryMeta(sectionId);
      if (!categoryMeta || !categoryMeta.handle) return { status: 'unsupported' };

      const modalRoot = document.querySelector('[data-size-advisor-modal][data-section="' + sectionId + '"]');
      const sizeGuidesUrl = modalRoot ? modalRoot.dataset.sizeGuidesUrl : null;
      const anthroUrl = modalRoot ? modalRoot.dataset.anthroUrl : null;

      const [sizeGuides, anthroDb] = await Promise.all([loadJson(sizeGuidesUrl), loadJson(anthroUrl)]);
      const guide = sizeGuides ? sizeGuides[categoryMeta.handle] : null;
      if (!guide) return { status: 'unsupported' };

      const type = classifyGuide(guide);
      if (type !== 'baby' && type !== 'kid') return { status: 'unsupported' };

      const tCol = tallaColumnKey(guide.columnas);
      const sex = profile.sex || categoryMeta.sex || null;

      if (type === 'baby') {
        const recommendedIndex = recommendBabyIndex(guide, profile);
        if (recommendedIndex === -1) return { status: 'unsupported' };
        return { status: 'ok', type, guide, tCol, sex, estimate: null, originalEstimate: null, anthroRows: null, recommendedIndex };
      }

      if (!anthroDb || !anthroDb.measurements) return { status: 'unsupported' };
      const { boy, girl } = anthroDb.measurements;
      const rows = sex === 'boy' ? boy : sex === 'girl' ? girl : averageAnthroRows(boy, girl);
      const ageEquivalentYears = estimateAgeByField(rows || [], profile.heightCm, 'height_cm');
      if (ageEquivalentYears == null) return { status: 'unsupported' };
      const anchorIndex = recommendKidIndex(guide, ageEquivalentYears);
      if (anchorIndex === -1) return { status: 'unsupported' };
      const estimate = estimateBodyByHeight(rows || [], profile.heightCm);
      const fitPreference = profile.fitPreference || 'medium';
      const recommendedIndex = refineIndexByPreference(guide, estimate, anchorIndex, fitPreference);
      return {
        status: 'ok',
        type,
        guide,
        tCol,
        sex,
        fitPreference,
        estimate,
        originalEstimate: estimate,
        anthroRows: rows,
        recommendedIndex,
      };
    }

    // --- Aplicar talla al selector de variantes ---
    // El `value` del <input type="radio"> es el option value completo de Shopify
    // (ej. "3 meses"), NO el texto corto que se muestra ("3M"). El texto visible
    // vive en el <label for="..."> asociado, así que hay que comparar contra eso.

    function getRadioLabelText(input) {
      const label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) return input.value;
      let text = '';
      label.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
      });
      return text.trim() || input.value;
    }

    function findVariantRadio(sectionId, talla) {
      const scope = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
      if (!scope) return null;
      const normalize = (value) => (value || '').trim().toLowerCase();
      const targetValue = normalize(talla);
      return Array.from(scope.querySelectorAll('input[type="radio"]')).find(
        (input) => normalize(getRadioLabelText(input)) === targetValue
      );
    }

    function applyRecommendation(sectionId, talla) {
      const target = findVariantRadio(sectionId, talla);
      if (!target) return { applied: false, reason: 'unavailable' };
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return { applied: true };
    }

    // Aplica la talla y, una vez que el selector de variantes termina de actualizarse
    // (evento async - ver product-info.js), envía el <product-form> real de la
    // sección para hacer un add-to-cart normal (carrito AJAX, notificación, etc).
    function addToCart(sectionId, talla) {
      const applyResult = applyRecommendation(sectionId, talla);

      let submitted = false;
      const doSubmit = () => {
        if (submitted) return;
        submitted = true;
        const productForm = document.querySelector('product-form[data-section-id="' + sectionId + '"]');
        const formEl = productForm && productForm.querySelector('form');
        if (!formEl) return;
        if (formEl.requestSubmit) formEl.requestSubmit();
        else formEl.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      };

      if (applyResult.applied && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event && event.data && event.data.sectionId && event.data.sectionId !== sectionId) return;
          unsubscribe();
          doSubmit();
        });
        setTimeout(doSubmit, 700);
      } else {
        doSubmit();
      }
      return applyResult;
    }

    async function maybeAutoApply(triggerRoot) {
      const sectionId = triggerRoot.dataset.section;
      const productId = triggerRoot.dataset.productId;
      if (AUTO_APPLIED.has(productId)) return;
      const profile = getActiveProfile();
      if (!profile) return;
      const rec = await buildRecommendation(sectionId, profile);
      if (rec.status !== 'ok') return;
      const talla = String(rec.guide.filas[rec.recommendedIndex][rec.tCol]).trim();
      applyRecommendation(sectionId, talla);
      AUTO_APPLIED.add(productId);
    }

    // --- UI: navegación de pasos ---

    function setDots(modalRoot, step) {
      const dotsEl = modalRoot.querySelector('[data-size-advisor-dots]');
      if (!dotsEl) return;
      dotsEl.querySelectorAll('span').forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === step - 1);
      });
    }

    function showStep(modalRoot, stepName) {
      modalRoot.querySelectorAll('[data-size-advisor-step]').forEach((stepEl) => {
        stepEl.hidden = stepEl.dataset.sizeAdvisorStep !== stepName;
      });
      modalRoot.querySelector('[data-size-advisor-unsupported]').hidden = true;
    }

    // --- Wizard: pantallas dentro del paso "profile" (lista / sexo / medidas) ---
    // direction 'forward' desliza la pantalla entrante desde la derecha (avanzar),
    // 'back' desde la izquierda (retroceder) - le da al flujo de crear/editar un
    // perfil la sensación de wizard con "pantallas" en vez de un simple show/hide.
    function showScreen(modalRoot, screenName, direction) {
      modalRoot.querySelectorAll('[data-size-advisor-screen]').forEach((screenEl) => {
        const isTarget = screenEl.dataset.sizeAdvisorScreen === screenName;
        screenEl.hidden = !isTarget;
        screenEl.classList.remove('is-sliding-in-left', 'is-sliding-in-right');
        if (isTarget) {
          void screenEl.offsetWidth;
          screenEl.classList.add(direction === 'back' ? 'is-sliding-in-left' : 'is-sliding-in-right');
        }
      });

      const dotsEl = modalRoot.querySelector('[data-size-advisor-dots]');
      if (dotsEl) {
        dotsEl.hidden = screenName === 'list';
        setDots(modalRoot, screenName === 'sex' ? 1 : 2);
      }

      // "Atrás" solo tiene sentido en la pantalla de sexo si hay una lista de
      // perfiles a la que volver - se recalcula acá (y no solo al crear un perfil
      // nuevo) para que también quede bien si se llega a esta pantalla desde
      // "Editar" -> "Atrás".
      if (screenName === 'sex') {
        const backToListBtn = modalRoot.querySelector('[data-size-advisor-back-to-list]');
        if (backToListBtn) backToListBtn.hidden = getProfiles().length === 0;
      }
    }

    function showUnsupported(modalRoot) {
      modalRoot.querySelectorAll('[data-size-advisor-step]').forEach((stepEl) => {
        stepEl.hidden = true;
      });
      modalRoot.querySelector('[data-size-advisor-unsupported]').hidden = false;
    }

    // --- UI: toggle de unidad para la edad (único que queda) ---

    // form.reset() no toca el toggle (no es un control del form), así que hay que
    // volverlo a su estado inicial a mano al cargar o limpiar el formulario.
    function setAgeUnit(modalRoot, unit) {
      const toggle = modalRoot.querySelector('[data-unit-toggle="age"]');
      toggle.dataset.currentUnit = unit;
      toggle.querySelectorAll('button').forEach((b) => b.classList.toggle('is-active', b.dataset.unit === unit));
    }

    function wireAgeUnitToggle(modalRoot) {
      const toggle = modalRoot.querySelector('[data-unit-toggle="age"]');
      const input = modalRoot.querySelector('[data-size-advisor-age]');
      setAgeUnit(modalRoot, 'years');

      toggle.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          const newUnit = btn.dataset.unit;
          const oldUnit = toggle.dataset.currentUnit;
          if (newUnit === oldUnit) return;

          const raw = parseFloat(input.value);
          if (!Number.isNaN(raw)) {
            const months = oldUnit === 'years' ? raw * 12 : raw;
            const displayValue = newUnit === 'years' ? months / 12 : months;
            input.value = Math.round(displayValue * 10) / 10;
          }

          toggle.dataset.currentUnit = newUnit;
          toggle.querySelectorAll('button').forEach((b) => b.classList.toggle('is-active', b === btn));
        });
      });
    }

    function readAgeMonths(modalRoot) {
      const toggle = modalRoot.querySelector('[data-unit-toggle="age"]');
      const input = modalRoot.querySelector('[data-size-advisor-age]');
      const raw = parseFloat(input.value);
      if (Number.isNaN(raw)) return null;
      return toggle.dataset.currentUnit === 'years' ? raw * 12 : raw;
    }

    // --- UI: sliders de comodidad (paso 3, solo lectura) ---

    // Versión sin clamp - usada para COMPARAR tallas entre sí (ej. al elegir la
    // que mejor calza con la preferencia del usuario). Categorías muy holgadas por
    // diseño (chaquetas, parkas) tienen ease muy por encima de EASE_MAX_CM en TODAS
    // sus tallas; si se compararan ya clampeadas, todas quedarían "empatadas" en
    // 100% y el desempate caería siempre en la talla más chica de la ventana,
    // reintroduciendo el sesgo que ya se corrigió una vez.
    function easeToRawPosition(ease) {
      return ((ease - EASE_MIN_CM) / (EASE_MAX_CM - EASE_MIN_CM)) * 100;
    }

    // Versión clampeada [0,100] - usada solo para dibujar la posición del
    // marcador dentro de la barra visual APRETADO/ANCHO.
    function easeToPosition(ease) {
      const clamped = Math.min(Math.max(ease, EASE_MIN_CM), EASE_MAX_CM);
      return ((clamped - EASE_MIN_CM) / (EASE_MAX_CM - EASE_MIN_CM)) * 100;
    }

    function renderSliders(container, guide, estimate, row, badDims) {
      container.innerHTML = '';
      if (!estimate) return;
      const badSet = new Set(badDims || []);

      availableDimensions(guide).forEach((dim) => {
        const garmentValue = row[dim.columnKey];
        const bodyValue = estimate[dim.bodyField];
        if (garmentValue == null || bodyValue == null) return;
        const position = easeToPosition(garmentValue - bodyValue);
        const isBad = badSet.has(dim.bodyField);

        const wrapper = document.createElement('div');
        wrapper.className = 'size-advisor-slider';
        wrapper.innerHTML =
          '<span class="size-advisor-slider__label">' + dim.label + '</span>' +
          '<div class="size-advisor-slider__track' + (isBad ? ' is-bad' : '') + '">' +
          '<span>APRETADO</span>' +
          '<div class="size-advisor-slider__marker" style="left: ' + position + '%"></div>' +
          '<span>ANCHO</span>' +
          '</div>';
        container.appendChild(wrapper);
      });
    }

    // --- UI: carrusel de tallas alternativas ---

    function renderAltSizes(modalRoot, rec, selectedIndex, onSelect) {
      const listEl = modalRoot.querySelector('[data-size-advisor-alt-list]');
      const wrapperEl = modalRoot.querySelector('[data-size-advisor-alt]');
      const prevBtn = modalRoot.querySelector('[data-alt-prev]');
      const nextBtn = modalRoot.querySelector('[data-alt-next]');
      const { guide, tCol, recommendedIndex } = rec;

      if (guide.filas.length <= 1) {
        wrapperEl.hidden = true;
        return;
      }
      wrapperEl.hidden = false;

      const windowIndexes = [selectedIndex - 1, selectedIndex, selectedIndex + 1].filter(
        (idx) => idx >= 0 && idx < guide.filas.length
      );

      listEl.innerHTML = '';
      windowIndexes.forEach((idx) => {
        const talla = String(guide.filas[idx][tCol]).trim();
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-advisor-alt__item';
        if (idx === selectedIndex) btn.classList.add('is-selected');
        const fit = evaluateFit(guide, rec.estimate, recommendedIndex, idx);
        if (fit.isBad) {
          btn.classList.add('is-not-recommended');
        } else if (idx === recommendedIndex) {
          btn.classList.add('is-recommended');
        }
        btn.textContent = talla;
        btn.addEventListener('click', () => onSelect(idx));
        listEl.appendChild(btn);
      });

      prevBtn.disabled = selectedIndex <= 0;
      nextBtn.disabled = selectedIndex >= guide.filas.length - 1;
      prevBtn.onclick = () => onSelect(Math.max(0, selectedIndex - 1));
      nextBtn.onclick = () => onSelect(Math.min(guide.filas.length - 1, selectedIndex + 1));
    }

    // --- Renderizado principal del paso 3 ---

    function renderResultForIndex(modalRoot, sectionId, rec, index) {
      const { guide, tCol, estimate, recommendedIndex } = rec;
      const row = guide.filas[index];
      const talla = String(row[tCol]).trim();

      const fit = evaluateFit(guide, estimate, recommendedIndex, index);

      const sizeEl = modalRoot.querySelector('[data-size-advisor-result-size]');
      sizeEl.textContent = talla;
      sizeEl.classList.remove('is-updating');
      void sizeEl.offsetWidth;
      sizeEl.classList.add('is-updating');

      const headlineEl = modalRoot.querySelector('[data-size-advisor-result-headline]');
      headlineEl.hidden = false;
      headlineEl.classList.toggle('is-bad', fit.isBad);
      headlineEl.querySelector('.size-advisor-result__title').textContent = fit.isBad
        ? 'No se recomienda'
        : index === recommendedIndex
          ? 'Es la mejor opción'
          : 'Buena opción';

      renderSliders(modalRoot.querySelector('[data-size-advisor-sliders]'), guide, estimate, row, fit.badDims);
      renderAltSizes(modalRoot, rec, index, (newIndex) => renderResultForIndex(modalRoot, sectionId, rec, newIndex));

      modalRoot.querySelector('[data-size-advisor-add-to-cart]').dataset.talla = talla;
    }

    async function runRecommendation(modalRoot, sectionId, profile) {
      // Cambiar de perfil dispara un cálculo async; si el usuario alcanza a elegir
      // otro antes de que termine el anterior, se descarta el resultado viejo para
      // que no pise en pantalla al del perfil recién elegido.
      const runId = (RUN_IDS.get(modalRoot) || 0) + 1;
      RUN_IDS.set(modalRoot, runId);
      const rec = await buildRecommendation(sectionId, profile);
      if (RUN_IDS.get(modalRoot) !== runId) return;
      recCache.set(modalRoot, rec.status === 'ok' ? rec : null);
      if (rec.status !== 'ok') {
        showUnsupported(modalRoot);
        return;
      }
      showStep(modalRoot, 'result');
      renderResultForIndex(modalRoot, sectionId, rec, rec.recommendedIndex);
    }

    // --- Paso "Mis medidas" ---

    function buildMeasureFieldRow(dim, valueCm) {
      const row = document.createElement('div');
      row.className = 'size-advisor-measure__field';
      row.dataset.bodyField = dim.bodyField;
      const min = Math.max(0, Math.round(valueCm - MEASURE_SLIDER_SPAN_CM));
      const max = Math.round(valueCm + MEASURE_SLIDER_SPAN_CM);
      row.innerHTML =
        '<div class="size-advisor-measure__field-top">' +
        '<label>' + dim.label + '</label>' +
        '<div class="size-advisor-measure__number-row">' +
        '<input type="number" step="0.5" min="' + min + '" max="' + max + '" value="' + valueCm.toFixed(1) + '">' +
        '<span>cm</span>' +
        '</div>' +
        '</div>' +
        '<input type="range" min="' + min + '" max="' + max + '" step="0.5" value="' + valueCm.toFixed(1) + '">';

      const range = row.querySelector('input[type="range"]');
      const number = row.querySelector('input[type="number"]');
      range.addEventListener('input', () => { number.value = range.value; });
      number.addEventListener('input', () => { range.value = number.value; });
      return row;
    }

    function openMeasureStep(modalRoot, rec, useOriginal) {
      const fieldsEl = modalRoot.querySelector('[data-size-advisor-measure-fields]');
      const moreBtn = modalRoot.querySelector('[data-size-advisor-measure-more]');
      fieldsEl.innerHTML = '';

      const source = useOriginal ? rec.originalEstimate : rec.estimate;
      const dims = availableDimensions(rec.guide).filter((dim) => source[dim.bodyField] != null);

      dims.forEach((dim, idx) => {
        const fieldRow = buildMeasureFieldRow(dim, source[dim.bodyField]);
        if (idx >= 2) fieldRow.hidden = true;
        fieldsEl.appendChild(fieldRow);
      });

      if (dims.length > 2) {
        moreBtn.hidden = false;
        moreBtn.textContent = 'Ver más medidas';
        moreBtn.onclick = () => {
          fieldsEl.querySelectorAll('.size-advisor-measure__field').forEach((el) => { el.hidden = false; });
          moreBtn.hidden = true;
        };
      } else {
        moreBtn.hidden = true;
      }

      showStep(modalRoot, 'measure');
    }

    function submitMeasureStep(modalRoot, sectionId, rec) {
      const fieldsEl = modalRoot.querySelector('[data-size-advisor-measure-fields]');
      const edited = {};
      fieldsEl.querySelectorAll('.size-advisor-measure__field').forEach((fieldRow) => {
        const value = parseFloat(fieldRow.querySelector('input[type="number"]').value);
        if (!Number.isNaN(value)) edited[fieldRow.dataset.bodyField] = value;
      });

      const ages = Object.keys(edited)
        .map((field) => estimateAgeByField(rec.anthroRows, edited[field], field))
        .filter((age) => age != null);
      if (!ages.length) return;

      const ageEquivalentYears = ages.reduce((a, b) => a + b, 0) / ages.length;
      const anchorIndex = recommendKidIndex(rec.guide, ageEquivalentYears);
      if (anchorIndex === -1) return;

      rec.estimate = { ...rec.estimate, ...edited };
      const newIndex = refineIndexByPreference(rec.guide, rec.estimate, anchorIndex, rec.fitPreference);
      rec.recommendedIndex = newIndex;

      showStep(modalRoot, 'result');
      renderResultForIndex(modalRoot, sectionId, rec, newIndex);
    }

    // --- Perfil guardado: saltar directo al resultado si ya existe ---

    // Al limpiar el formulario se vuelve a la sugerencia de sexo del producto
    // (dataset.suggestedSex, sacada de los tags), no a "ninguno".
    function setSexSelection(modalRoot, sex) {
      modalRoot.querySelectorAll('[data-sex-option]').forEach((btn) => {
        btn.classList.toggle('is-active', Boolean(sex) && btn.dataset.sexOption === sex);
      });
    }

    function setFormError(modalRoot, message) {
      const errorEl = modalRoot.querySelector('[data-size-advisor-error]');
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function fillFormFromProfile(modalRoot, profile) {
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      setFormError(modalRoot, '');
      formEl.dataset.editingId = profile.id || '';
      modalRoot.querySelector('[data-size-advisor-name]').value = profile.name || '';
      modalRoot.querySelector('[data-size-advisor-height]').value = profile.heightCm;
      modalRoot.querySelector('[data-size-advisor-weight]').value = profile.weightKg;
      setAgeUnit(modalRoot, 'years');
      modalRoot.querySelector('[data-size-advisor-age]').value = Math.round((profile.ageMonths / 12) * 10) / 10;
      setSexSelection(modalRoot, profile.sex);
      modalRoot.querySelectorAll('[data-fit-option]').forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.fitOption === (profile.fitPreference || 'medium'));
      });
    }

    // --- Panel de perfiles guardados: listar, seleccionar, editar, eliminar ---

    // El glifo (✎ / ✕) queda aria-hidden: es decorativo y los lectores de pantalla
    // lo leerían como un símbolo suelto - el texto real va en el aria-label.
    function buildProfileIconButton(className, glyph, label, onClick) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = className;
      btn.setAttribute('aria-label', label);
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = glyph;
      btn.appendChild(icon);
      btn.addEventListener('click', onClick);
      return btn;
    }

    function renderProfilesPanel(modalRoot, sectionId) {
      const listEl = modalRoot.querySelector('[data-size-advisor-profiles-list]');
      const profiles = getProfiles();
      const activeId = getActiveProfileId();

      listEl.innerHTML = '';

      if (!profiles.length) return;

      profiles.forEach((profile) => {
        const isActive = profile.id === activeId;
        const displayName = profile.name || 'Sin nombre';
        const item = document.createElement('div');
        item.className = 'size-advisor-profiles__item' + (isActive ? ' is-active' : '');

        const selectBtn = document.createElement('button');
        selectBtn.type = 'button';
        selectBtn.className = 'size-advisor-profiles__select';
        selectBtn.textContent = displayName;
        if (isActive) selectBtn.setAttribute('aria-current', 'true');
        selectBtn.addEventListener('click', () => selectProfile(modalRoot, sectionId, profile.id));
        item.appendChild(selectBtn);

        item.appendChild(
          buildProfileIconButton('size-advisor-profiles__edit', '✎', 'Editar el perfil ' + displayName, () =>
            openEditProfileForm(modalRoot, profile)
          )
        );
        item.appendChild(
          buildProfileIconButton('size-advisor-profiles__delete', '✕', 'Eliminar el perfil ' + displayName, () =>
            deleteProfile(modalRoot, sectionId, profile.id)
          )
        );

        listEl.appendChild(item);
      });
    }

    function selectProfile(modalRoot, sectionId, id) {
      const profile = getProfiles().find((p) => p.id === id);
      if (!profile) return;
      setActiveProfileId(id);
      fillFormFromProfile(modalRoot, profile);
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'form', 'forward');
      renderProfilesPanel(modalRoot, sectionId);
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = false;
      runRecommendation(modalRoot, sectionId, profile);
    }

    // Primera pantalla del wizard de creación: elegir sexo. "Atrás" solo tiene
    // sentido si hay una lista de perfiles a la que volver.
    function openNewProfileForm(modalRoot, direction) {
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      const fitRow = modalRoot.querySelector('[data-size-advisor-fit-row]');
      formEl.reset();
      formEl.dataset.editingId = '';
      setFormError(modalRoot, '');
      setAgeUnit(modalRoot, 'years');
      setSexSelection(modalRoot, modalRoot.dataset.suggestedSex);
      fitRow.querySelectorAll('[data-fit-option]').forEach((b) => b.classList.toggle('is-active', b.dataset.fitOption === 'medium'));

      modalRoot.querySelector('[data-size-advisor-sex-next]').disabled = !modalRoot.dataset.suggestedSex;
      // Con perfiles guardados, "Cambiar de perfil" es otra salida para volver a la lista.
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = getProfiles().length === 0;
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'sex', direction || 'forward');
    }

    // Editar un perfil existente ya conoce el sexo: salta directo a la pantalla
    // de medidas en vez de pasar de nuevo por la de sexo.
    function openEditProfileForm(modalRoot, profile) {
      fillFormFromProfile(modalRoot, profile);
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = false;
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'form', 'forward');
    }

    // Vista "elige un perfil": solo la lista (salvo que no haya ninguno guardado,
    // en cuyo caso no hay nada que elegir y se salta directo a crear el primero).
    function showProfilesList(modalRoot, sectionId, direction) {
      renderProfilesPanel(modalRoot, sectionId);
      if (!getProfiles().length) {
        openNewProfileForm(modalRoot, direction);
        return;
      }
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      formEl.dataset.editingId = '';
      setFormError(modalRoot, '');
      setSexSelection(modalRoot, modalRoot.dataset.suggestedSex);
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = true;
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'list', direction || 'back');
    }

    function deleteProfile(modalRoot, sectionId, id) {
      const profile = getProfiles().find((p) => p.id === id);
      if (!profile) return;
      if (!window.confirm('¿Eliminar el perfil ' + (profile.name || 'sin nombre') + '?')) return;
      saveProfiles(getProfiles().filter((p) => p.id !== id));

      // Si el formulario estaba editando justo este perfil, soltar el id: si no,
      // el siguiente "Siguiente" lo revive como perfil nuevo.
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      if (formEl.dataset.editingId === id) {
        formEl.dataset.editingId = '';
      }

      // Al borrar el perfil activo no se elige otro por el usuario: se vuelve a la
      // lista para que elija, en vez de saltar a la recomendación de un perfil
      // cualquiera.
      if (getActiveProfileId() === id) {
        setActiveProfileId(null);
        showProfilesList(modalRoot, sectionId);
        return;
      }
      renderProfilesPanel(modalRoot, sectionId);
    }

    function initModal(modalRoot, sectionId, categoryMeta) {
      const sexRow = modalRoot.querySelector('[data-size-advisor-sex-row]');
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      const switchBtn = modalRoot.querySelector('[data-size-advisor-switch-profile]');
      const sexNextBtn = modalRoot.querySelector('[data-size-advisor-sex-next]');

      if (categoryMeta && categoryMeta.sex) {
        modalRoot.dataset.suggestedSex = categoryMeta.sex;
        setSexSelection(modalRoot, categoryMeta.sex);
      }

      // Elegir sexo solo marca la selección - avanzar a la pantalla de medidas
      // es una acción explícita del usuario vía el botón "Siguiente".
      sexRow.querySelectorAll('[data-sex-option]').forEach((btn) => {
        btn.addEventListener('click', () => {
          sexRow.querySelectorAll('[data-sex-option]').forEach((b) => b.classList.toggle('is-active', b === btn));
          sexNextBtn.disabled = false;
        });
      });

      sexNextBtn.addEventListener('click', () => {
        showScreen(modalRoot, 'form', 'forward');
        modalRoot.querySelector('[data-size-advisor-name]').focus();
      });

      modalRoot.querySelector('[data-size-advisor-back-to-list]').addEventListener('click', () => {
        showProfilesList(modalRoot, sectionId, 'back');
      });

      modalRoot.querySelector('[data-size-advisor-back-to-sex]').addEventListener('click', () => {
        showScreen(modalRoot, 'sex', 'back');
      });

      wireAgeUnitToggle(modalRoot);

      const fitRow = modalRoot.querySelector('[data-size-advisor-fit-row]');
      fitRow.querySelectorAll('[data-fit-option]').forEach((btn) => {
        btn.addEventListener('click', () => {
          fitRow.querySelectorAll('[data-fit-option]').forEach((b) => b.classList.toggle('is-active', b === btn));
        });
      });

      formEl.addEventListener('submit', (event) => {
        event.preventDefault();
        const name = modalRoot.querySelector('[data-size-advisor-name]').value.trim();
        const heightCm = parseFloat(modalRoot.querySelector('[data-size-advisor-height]').value);
        const weightKg = parseFloat(modalRoot.querySelector('[data-size-advisor-weight]').value);
        const ageMonths = readAgeMonths(modalRoot);
        const sexBtn = sexRow.querySelector('.is-active');
        const fitBtn = fitRow.querySelector('.is-active');

        // ageMonths se compara contra null y no por falsy: 0 meses (recién nacido)
        // es un valor válido en las categorías de bebé.
        if (!name || !heightCm || !weightKg || ageMonths == null) {
          setFormError(modalRoot, 'Completa el nombre, altura, peso y edad para continuar.');
          return;
        }

        const editingId = formEl.dataset.editingId;
        const profiles = getProfiles();
        const nameTaken = profiles.some(
          (p) => p.id !== editingId && (p.name || '').trim().toLowerCase() === name.toLowerCase()
        );
        if (nameTaken) {
          setFormError(modalRoot, 'Ya tienes un perfil con ese nombre. Usa otro para poder distinguirlos.');
          return;
        }
        setFormError(modalRoot, '');

        let profile = editingId ? profiles.find((p) => p.id === editingId) : null;
        if (!profile) {
          profile = { id: generateProfileId() };
          profiles.push(profile);
        }
        profile.name = name;
        profile.heightCm = heightCm;
        profile.weightKg = weightKg;
        profile.ageMonths = ageMonths;
        profile.sex = sexBtn ? sexBtn.dataset.sexOption : null;
        profile.fitPreference = fitBtn ? fitBtn.dataset.fitOption : 'medium';
        profile.updatedAt = new Date().toISOString();

        saveProfiles(profiles);
        setActiveProfileId(profile.id);
        formEl.dataset.editingId = profile.id;
        switchBtn.hidden = false;
        renderProfilesPanel(modalRoot, sectionId);
        runRecommendation(modalRoot, sectionId, profile);
      });

      modalRoot.querySelector('[data-size-advisor-profiles-add]').addEventListener('click', () => {
        openNewProfileForm(modalRoot, 'forward');
      });

      switchBtn.addEventListener('click', () => {
        showProfilesList(modalRoot, sectionId, 'back');
      });

      modalRoot.querySelector('[data-size-advisor-edit]').addEventListener('click', () => {
        const rec = recCache.get(modalRoot);
        if (rec && rec.type === 'kid') {
          openMeasureStep(modalRoot, rec, false);
        } else {
          showStep(modalRoot, 'profile');
          showScreen(modalRoot, 'form', 'back');
        }
      });

      modalRoot.querySelector('[data-size-advisor-measure-reset]').addEventListener('click', () => {
        const rec = recCache.get(modalRoot);
        if (rec) openMeasureStep(modalRoot, rec, true);
      });

      modalRoot.querySelector('[data-size-advisor-measure-submit]').addEventListener('click', () => {
        const rec = recCache.get(modalRoot);
        if (rec) submitMeasureStep(modalRoot, sectionId, rec);
      });

      modalRoot.querySelector('[data-size-advisor-add-to-cart]').addEventListener('click', (event) => {
        const talla = event.currentTarget.dataset.talla;
        if (!talla) return;
        addToCart(sectionId, talla);
      });
    }

    function initModals() {
      migrateLegacyProfile();
      document.querySelectorAll('[data-size-advisor-modal]').forEach((modalRoot) => {
        if (modalRoot.dataset.initialized === 'true') return;
        modalRoot.dataset.initialized = 'true';
        const sectionId = modalRoot.dataset.section;
        const categoryMeta = getCategoryMeta(sectionId);

        initModal(modalRoot, sectionId, categoryMeta);

        const activeProfile = getActiveProfile();
        if (activeProfile) {
          renderProfilesPanel(modalRoot, sectionId);
          fillFormFromProfile(modalRoot, activeProfile);
          showStep(modalRoot, 'profile');
          showScreen(modalRoot, 'form', 'forward');
          modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = false;
          runRecommendation(modalRoot, sectionId, activeProfile);
        } else {
          showProfilesList(modalRoot, sectionId, 'forward');
        }
      });
    }

    function initTriggers() {
      document.querySelectorAll('[data-size-advisor-trigger]').forEach((triggerRoot) => {
        maybeAutoApply(triggerRoot);
        if (triggerRoot.dataset.initialized === 'true') return;
        triggerRoot.dataset.initialized = 'true';
      });
    }

    initModals();
    initTriggers();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => initTriggers());
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
